module.exports = __webpack_public_path__ + "images/psp/SizeGuide/motorcycle/5x15.svg";